<template>
<div class="chapter">
<div class="inner_page">
<div class="Acknowledgements" id="Acknowledgements">
<p class="chapterTitle">Acknowledgements</p>
<p class="paraNoIndent"><span class="dropcap">M</span>y thanks go to the following for their co-operation and spirit of friendliness in the production of this book: the editor and staff of the Isle of Wight <em class="italic">County Press</em>, the licensees and staff of the <em class="italic">Hare and Hounds </em>public house, Downend, the licensees and staff of the <em class="italic">Buddle Inn</em>, Niton, the churchwarden and PCC, Newport Minster, Andrew Ross, Hairdressing, Newport, Just You beauticians, Newport.</p>
<p class="para">I would also like to thank Mrs Debbie Galvin for her help, and above all my good lady wife, Carol Trow, for many hours trekking over the Isle of Wight in all weathers to take the photographs in this book. And finally to my son, Tali, who knows where the bodies are buried!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?5f9491d9